import { render } from "./MemoryReportNew.vue?vue&type=template&id=3aa7fae4&scoped=true&ts=true"
import script from "./MemoryReportNew.vue?vue&type=script&lang=ts"
export * from "./MemoryReportNew.vue?vue&type=script&lang=ts"

import "./MemoryReportNew.vue?vue&type=style&index=0&id=3aa7fae4&scoped=true&lang=css"
import "./MemoryReportNew.vue?vue&type=style&index=1&id=3aa7fae4&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa7fae4"]])

export default __exports__